import { z } from "zod";

import { DISCRIMINATOR } from "./common";

const DEFAULT_STATUS = 204;

function zNoBody(): ReturnType<typeof _zNoBody<typeof DEFAULT_STATUS>>;
function zNoBody<Status extends number>(status: Status): ReturnType<typeof _zNoBody<Status>>;
function zNoBody<Status extends number = typeof DEFAULT_STATUS>(status?: Status) {
  return _zNoBody(status ?? DEFAULT_STATUS);
}

function _zNoBody<Status extends number>(status: Status) {
  return z.object({
    [DISCRIMINATOR]: z.literal(status),
  });
}

export { zNoBody };
